jQuery(function ($) {
	$(".openFormAssocie").on("click", function () {
		const $form = $(".s-form-associe");
		if ($form.hasClass("opened")) {
			$form.slideUp();
			$form.removeClass("opened");
			$(".openFormAssocie").each(function () {
				$(this).removeClass("close").html($(this).attr("data-save"));
				$(this).attr("data-save", "");
			});
		} else {
			$(".openFormAssocie").each(function () {
				$(this).addClass("close").attr("data-save", $(this).html());
				$(this).html("FECHAR FORMULÁRIO");
			});
			$form.addClass("opened");
			$form.slideDown();
			var target = $form.offset().top;
			$("html, body")
				.stop()
				.animate({ scrollTop: target - 31 }, 600);
			$(".s-form-associe form .block:first-child input").focus();
		}
	});
});

import '../graficos/genero';
import '../graficos/perfil';
import '../graficos/cor-raca';
import '../graficos/genero-psp';
import '../graficos/instituicao-psp';
import '../graficos/cor-raca-psp';
import '../graficos/aposentadoria-reserva';


